<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 10:38:15
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-10 14:48:24
 * @Description: 结算价
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\monthlyReportUnitRecord.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <!-- <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
        </el-collapse-transition> -->
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">主合同单位</span>
              <el-input v-model="tableParam.supplierName" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <el-table-column align="center" label="合同编号" prop="code"></el-table-column>
              <el-table-column align="center" label="合同签订主体" min-width="230" prop="contractSigningSubject"></el-table-column>
              <el-table-column align="center" label="主合同单位" prop="supplierName"></el-table-column>
              <el-table-column align="center" label="确认状态" prop>
                <template slot-scope="scope">
                  <span>{{ mouthReportStatusList | fromatTable(scope.row.outerSettlePriceStatus, "name", "id") }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.outerSettlePriceStatus != 1" type="success" :underline="false" @click="toConfirm(scope.row)">{{scope.row.outerSettlePriceStatus == 2 ? '更新':'去确认'}}</el-link>
                  <el-link v-else type="success" :underline="false" @click="toConfirm(scope.row)">查看</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage } from  "@/api/wise/Wise_contactsbusiness/contactPriceList.js";
import { getUserInfo } from "@/utils/auth.js";

export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      pagesType: 0,
      mouthReportStatusList: [
        { name: "待确认", id: 0 },
        { name: "已确认", id: 1 },
        { name: "待更新", id: 2 },
        { name: "无数据", id: 3 },
      ],
      params:{},
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.params = this.$route.query;
    this.tableParam = { ...this.tableParam, supplierName: "",contractTypeId:this.params.contractTypeId };
    this.init();
    this.gettableData();
  },

  methods: {
    init() {
      /*重置数据*/
      this.tableParam.supplierName = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    //   去确认
    toConfirm(row) {
      this.$router.push({ name: "contactList", query: { row: JSON.stringify(row),contractTypeId:this.params.contractTypeId } });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.styleA {
  overflow: auto;
  max-height: calc(85vh - 266px);
  padding-right: 10px;
}
.styleB {
  overflow: auto;
  max-height: calc(85vh - 366px);
  padding-right: 10px;
}
.saledialoginfo {
  padding: 20px 20px 0 0px;
  max-height: calc(85vh - 220px);
}
.el-input,
.el-select {
  width: 240px;
}
.top_link {
  color: #008000;
}
.top_link:hover {
  cursor: pointer;
  opacity: 0.7;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;
  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }
    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
.el-input,
.el-select {
  width: 227px;
}
.dialoginfo {
  padding: 0;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
</style>
  